import React from "react";
import { useQuery } from "@apollo/client/react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { REVISION_LOGS_QUERY } from "../constants/graphql/queries";
import RevisionLogItem from "./RevisionLogItem";

export default function RevisionLogModal({ itemId, itemType, onClose }) {
  const { data, loading, error } = useQuery(REVISION_LOGS_QUERY, {
    variables: { itemId, itemType },
    skip: !itemId || !itemType,
  });

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography fontWeight={500} fontSize={22} align="center" color="textPrimary">
          Revision Log
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ minHeight: 400, bgcolor: "#f4f6f8" }}>
        {loading && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Alert severity="error" sx={{ my: 1 }}>
            Failed to load revision logs.
          </Alert>
        )}
        {!loading && !error && (
          <>
            {!data?.revisionLogs || data.revisionLogs.length === 0 ? (
              <Typography color="textSecondary" textAlign="center" mt={4}>
                No changes found.
              </Typography>
            ) : (
              <Box>
                {data.revisionLogs.map((log, idx) => (
                  <RevisionLogItem key={log.id || idx} log={log} />
                ))}
              </Box>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
